module.exports = __webpack_public_path__ + "img/convenience-store.9738ba3d.svg";